import { Banner } from '@forge/common';

interface MockDataBannerProps {
  featureName?: string;
}

const MockDataBanner = ({ featureName = 'This page' }: MockDataBannerProps) => {
  return (
    <Banner
      variant="inline"
      type="info"
      title=""
      hideIcon
      canClose={false}
      description={`${featureName} is displaying mock data for demonstration purposes. Changes will not be persisted and will reset on page reload.`}
    />
  );
};

export default MockDataBanner;
